import { riflemanSkinForMapId, type GameState } from "@dailywars/core/engine";
import { useEffect, useRef, useState, type ReactNode } from "react";

import { Spinner } from "#/components/ui/spinner";
import { preloadBoardImages } from "#/game/boardImagePreload";
import { setActiveRiflemanSkin } from "#/game/unitSprites";

export function BoardImagesGate({
  state,
  mapId,
  children,
}: {
  state: GameState;
  mapId?: string;
  children: ReactNode;
}) {
  const [ready, setReady] = useState(false);
  const stateRef = useRef(state);
  const skin = mapId ? riflemanSkinForMapId(mapId) : undefined;

  useEffect(() => {
    let cancelled = false;
    setActiveRiflemanSkin(skin);
    void preloadBoardImages(stateRef.current).then(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
      setActiveRiflemanSkin(undefined);
    };
  }, [skin]);

  if (!ready) {
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <Spinner className="size-8 text-muted-foreground" />
      </div>
    );
  }

  return <>{children}</>;
}
